import type { ThemeConfig, ColorScale } from './theme.types';

const primaryPalette: ColorScale = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00838d',
  600: '#00768a',
  700: '#006978',
  800: '#005b66',
  900: '#004d54',
};

const secondaryPalette: ColorScale = {
  50: '#f1f5f9',
  100: '#e2e8f0',
  200: '#cbd5e1',
  300: '#94a3b8',
  400: '#64748b',
  500: '#475569',
  600: '#334155',
  700: '#1e293b',
  800: '#0f172a',
  900: '#020617',
};

const neutralPalette: ColorScale = {
  50: '#f8fafc',
  100: '#f1f5f9',
  200: '#e2e8f0',
  300: '#cbd5e1',
  400: '#94a3b8',
  500: '#64748b',
  600: '#475569',
  700: '#334155',
  800: '#1e293b',
  900: '#0f172a',
};

export const defaultTheme: ThemeConfig = {
  colors: {
    background: '#ffffff',
    foreground: neutralPalette[900],
    muted: neutralPalette[100],
    mutedForeground: neutralPalette[500],
    border: neutralPalette[200],
    input: neutralPalette[200],
    ring: primaryPalette[500],
    primary: primaryPalette[500],
    primaryForeground: '#ffffff',
    secondary: neutralPalette[100],
    secondaryForeground: neutralPalette[900],
    destructive: '#e53935',
    destructiveForeground: '#ffffff',
    accent: neutralPalette[100],
    accentForeground: neutralPalette[900],
    card: '#ffffff',
    cardForeground: neutralPalette[900],
    popover: '#ffffff',
    popoverForeground: neutralPalette[900],
    success: '#16a34a',
    successForeground: '#ffffff',
    warning: '#d97706',
    warningForeground: '#ffffff',
    info: '#2563eb',
    infoForeground: '#ffffff',
  },
  palettes: {
    primary: primaryPalette,
    secondary: secondaryPalette,
    neutral: neutralPalette,
  },
  typography: {
    fontFamily: {
      sans: "'Inter', ui-sans-serif, system-ui, sans-serif",
    },
    fontSize: {
      base: { mobile: '18px', desktop: '19px' },
    },
  },
  radii: {
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
  },
};

export type { ThemeConfig, ColorScale, SemanticColors, Typography, Radii } from './theme.types';
